<template>
  <div class="gscbm-container">
    <div :class="classNameSearch()">
      <input
        v-model="searchValue"
        type="text"
        :placeholder="'Search ' + searchThing"
      />
      <img src="../assets/SearchIconGrey.svg" />
    </div>
    <div class="gscbm-bottom-subcontainer">
      <div
        v-for="thing of filteredThings"
        :key="'filter-list-' + searchThing + '-' + thing.uuid"
        :value="thing.uuid"
        :class="classNameItemRow(thing.uuid)"
      >
        <input
          @input="$emit(`${searchThing}-checked`, thing.uuid)"
          type="checkbox"
          class="gscbm-checkbox"
          :checked="checked.includes(thing.uuid)"
        />
        <div :class="classNameTitle(thing.uuid)">
          {{ thing[displayProperty] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchThing: {
      type: String,
      default: () => {
        return 'thing'
      }
    },
    displaySearch: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    things: {
      type: Array,
      default: () => {
        return []
      }
    },
    displayProperty: {
      type: String,
      default: () => {
        return ''
      }
    },
    checked: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      searchValue: ''
    }
  },
  computed: {
    filteredThings() {
      this.things.sort((a, b) => a.name.localeCompare(b.name))

      if (!this.searchValue || !this.displayProperty) return this.things
      const regex = new RegExp(this.searchValue, 'gi')
      const filtered = []
      for (const thing of this.things) {
        if (thing[this.displayProperty].toLowerCase().match(regex))
          filtered.push(thing)
      }
      if (filtered.length < 1) return this.things
      return filtered
    }
  },
  methods: {
    classNameItemRow(uuid) {
      let thisClassName = 'gscbm-item-row'

      if (uuid == 'green') thisClassName += ' bg-green'
      else if (uuid == 'yellow') thisClassName += ' bg-yellow'
      else if (uuid == 'red') thisClassName += ' bg-red'
      return thisClassName
    },

    classNameTitle(uuid) {
      let thisClassName = 'gscbm-item-title'

      if (uuid == 'green') thisClassName += ' font-green'
      else if (uuid == 'yellow') thisClassName += ' font-yellow'
      else if (uuid == 'red') thisClassName += ' font-red'
      return thisClassName
    },

    classNameSearch() {
      let thisClassName = 'gscbm-top-subcontainer'

      if (this.displaySearch == 'false') thisClassName += ' display-none'
      return thisClassName
    }
  }
}
</script>

<style scoped>
.gscbm-container {
  background: white;
  border: 0.5px solid #dfdfdf;
  box-sizing: border-box;
  box-shadow: 0px 4px 16px rgba(43, 45, 55, 0.05);
  border-radius: 4px;
  z-index: 1;
}

.gscbm-bottom-subcontainer {
  max-height: 300px;
  min-width: 208px;
  overflow-y: scroll;
}

.gscbm-top-subcontainer {
  position: relative;
  padding: 16px;
  min-width: 208px;
  min-height: 32px;
}

.gscbm-top-subcontainer input {
  border: 1px solid #dfdfdf;
  box-sizing: border-box;
  border-radius: 5px;
  width: 208px;
  height: 32px;
  padding-left: 16px;
}

.gscbm-top-subcontainer img {
  position: absolute;
  right: 24px;
  top: 24px;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
  supported by Chrome, Edge, Opera and Firefox */
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
}

.gscbm-item-row {
  display: flex;
  flex-flow: row nowrap;
  border-top: 0.5px solid rgba(216, 222, 228, 0.5);
  border-bottom: 0.5px solid rgba(216, 222, 228, 0.5);
  min-height: 40px;
  align-items: center;
  justify-content: left;
  padding-left: 16px;
}

.gscbm-item-title {
  margin-left: 16px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 13px;
  display: flex;
  align-items: center;
  color: #4a4a4a;
}

.bg-green {
  background: rgba(24, 169, 0, 0.1);
}

.bg-yellow {
  background: rgba(227, 151, 2, 0.1);
}

.bg-red {
  background: rgba(204, 0, 0, 0.1);
}

.font-green {
  color: #18a900;
}

.font-yellow {
  color: #e39702;
}

.font-red {
  color: #c00;
}

.display-none {
  display: none !important;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .gscbm-container {
    min-width: 280px;
    max-width: 90vw;
  }

  .gscbm-top-subcontainer {
    padding: 12px;
  }

  .gscbm-top-subcontainer input {
    width: 100%;
    height: 44px;
    font-size: 16px;
    padding-left: 12px;
  }

  .gscbm-top-subcontainer img {
    right: 16px;
    top: 20px;
    width: 20px;
    height: 20px;
  }

  .gscbm-bottom-subcontainer {
    min-width: 100%;
    max-height: 300px;
  }

  .gscbm-item-row {
    padding: 12px;
    min-height: 48px;
  }

  .gscbm-item-title {
    font-size: 14px;
    line-height: 18px;
    margin-left: 12px;
  }

  .gscbm-checkbox {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 480px) {
  .gscbm-container {
    min-width: 250px;
    max-width: 95vw;
  }

  .gscbm-top-subcontainer {
    padding: 10px;
  }

  .gscbm-top-subcontainer input {
    height: 40px;
    font-size: 16px;
  }

  .gscbm-item-row {
    padding: 10px;
    min-height: 44px;
  }

  .gscbm-item-title {
    font-size: 13px;
    line-height: 16px;
  }
}
</style>
